import axios from "axios";
import { datadogRum } from "@datadog/browser-rum";
import { drw_endpoint_url } from "./api";

export interface ShortenUrlApiParams {
  url: string;
  partnerCode: string;
  usageId: string;
}

export interface UrlShortenerResponse {
  errorMessage?: string | null;
  status?: string;
  shortUrl?: string;
}

export async function shortenUrlApi(
  params: ShortenUrlApiParams
): Promise<UrlShortenerResponse> {
  try {
    const response = await axios.post(
      `${drw_endpoint_url}/api/drw/urlShortener`,
      { url: params.url },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    datadogRum.addAction("[shortenUrl] URL Shortener API success", {
      url: params.url,
      status: response?.data?.status,
    });

    if (response?.data?.errorMessage) {
      datadogRum.addError(
        new Error(
          `URL Shortener API failed with message ${response?.data?.errorMessage}`
        ),
        {
          partnerCode: params.partnerCode,
          usageId: params.usageId,
          url: params.url,
        }
      );
    }

    return response.data;
  } catch (error: any) {
    datadogRum.addError(
      new Error(
        `URL Shortener API failed with status ${error?.response?.status}`
      ),
      {
        partnerCode: params.partnerCode,
        usageId: params.usageId,
        url: params.url,
        error,
      }
    );

    throw error;
  }
}
